module.exports = __webpack_public_path__ + "img/can7.e4aa795e.png";